$('[data-toggle="menu"]').click(function(e){

	e.preventDefault();

	$('.menu, .menu-principal , .bg-topo').addClass('active');
});

$('.toggle-categorias').click(function(e){

	e.preventDefault();

	$('.bg-topo').addClass('active');
	$('.categorias-principais').toggleClass('active');
});

$('[data-toggle="search"]').click(function(){
	$('.buscas, .bg-topo').addClass('active');
});

$('.bg-topo').click(function(){
	$('.categorias-principais, .bg-topo, .menu-principal, .menu, .buscas').removeClass('active');
});